import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/Button';

import shapeImg1 from '../../assets/img/hero/shape-4-1.png';
import shapeImg2 from '../../assets/img/hero/shape-4-2.png';
import shapeImg3 from '../../assets/img/hero/shape-4-3.png';
import heroImg from '../../assets/img/hero/hero-4-1.jpg';
import heroIcon from '../../assets/img/hero/icon-1.png';

const Hero = () => {
  return (
    <div className="it-hero-4-area it-hero-4-wrapper fix p-relative z-index">
      <div className="it-hero-4-shape-1">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="it-hero-4-shape-2">
        <img src={shapeImg2} alt="" />
      </div>
      <div className="container">
        <div className="row align-items-xl-end align-items-center">
          <div className="col-xl-7 col-lg-6">
            <div className="it-hero-content">
              <h1
                className="it-hero-title text-white pb-10 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
              >
                تقديم الأفضل الطبية على الانترنت <span>الاستشارة</span>
              </h1>
              <div
                className="it-hero-text mb-35 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".5s"
              >
                <p>
                  من المهم الاعتناء بالمريض ومتابعة عملية التدريب، لكنها مسألة
                  وقت فقط <br />
                  لقد حدث ذلك مع بعض المخاض والألم الشديد
                </p>
              </div>
              <div
                className="it-hero-button-wrapper wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".7s"
              >
                <Link to="/about-us" className="it-btn-theme grey-bg">
                  <Button btnText="اكتشف المزيد" />
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-lg-6">
            <div className="it-hero-4-right text-center d-lg-start p-relative">
              <div className="it-hero-4-thumb p-relative">
                <img src={heroImg} alt="" />
                <div className="it-hero-4-shape-3 d-none d-xl-block">
                  <img src={shapeImg3} alt="" />
                </div>
              </div>
              <div className="it-hero-doctor-wrap">
                <div className="it-hero-doctor-box d-flex align-items-center justify-content-start">
                  <div className="it-hero-doctor-icon">
                    <span>
                      <img src={heroIcon} alt="" />
                    </span>
                  </div>
                  <div className="it-hero-doctor-text text-end">
                    <span>200+</span>
                    <p>
                      أفضل الأطباء في العال <br />
                      التشاور
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
